import { isPossiblePhoneNumber } from 'react-phone-number-input';

export default function isValidPhone(value: string | undefined | null) {
    return isPossiblePhoneNumber(value || '');
}
